module.exports = __webpack_public_path__ + "static/media/multan.a48fb0c1.svg";